import React, { forwardRef } from 'react'
import { Alert as BaseAlert, styled } from '@mui/material'
import { Cancel as BaseErrorIcon, Error as BaseWarningIcon, Info as BaseInfoIcon } from '@mui/icons-material'
import BaseSuccessIcon from '../Icons/SuccessIcon'
import { PALETTE_DICTIONARY } from '../Theme/Theme.utils'

export const Title = styled('span')`
  color: ${props => props.theme.palette.gray[20]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  padding-right: 6px;
`

export const Subtitle = styled('span')`
  color: ${props => props.theme.palette.gray[35]};
  font-family: ${props => props.theme.typography.fontFamily};
`

export const Body = styled('p')`
  color: ${props => props.theme.palette.gray[35]};
  display: block;
  font-family: ${props => props.theme.typography.fontFamily};
  margin: 0;
`

export const Root = styled(
  forwardRef(({ children, disableBackground, severity, textDirection, ...props }, ref) => (
    <BaseAlert ref={ref} {...props}>
      {children}
    </BaseAlert>
  ))
)`
  &.MuiAlert-root {
    color: ${({ disableBackground, theme }) => theme.palette.gray[disableBackground ? 50 : 20]};
    background-color: ${({ severity, theme, disableBackground }) =>
      disableBackground ? theme.palette.brand.white : theme.palette[PALETTE_DICTIONARY[severity]][95]};
    border: ${({ border, severity, theme }) =>
      border ? `1px solid ${theme.palette[PALETTE_DICTIONARY[severity]][50]}` : 'none'};
    border-radius: 4px;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    justify-content: ${props => {
      switch (props.align) {
        case 'center':
        case 'inherit':
          return props.align
        case 'right':
          return 'flex-end'
        case 'justify':
          return ''
        case 'left':
        default:
          return 'flex-start'
      }
    }};
    letter-spacing: 0;
    line-height: 18px;
    margin: ${props => props.margin};
    padding: ${props => props.padding || '11px 16px'};
    width: ${props => props.width || 'auto'};

    &.MuiAlert-icon {
      align-items: ${props => (props.textDirection === 'vertical' ? 'flerx-start' : 'center')};
      margin: 0 12px 0 0;
    }

    &.MuiAlert-message {
      align-items: center;
      display: ${props => (props.textDirection === 'vertical' ? 'block' : 'flex')};
      padding: 0;
    }
  }
`

export const DefaultIcon = styled(BaseInfoIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.gray[50]};
    font-size: 1.2003rem;
  }
`

export const ErrorIcon = styled(BaseErrorIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.red[50]};
    font-size: 1.2003rem;
  }
`

export const InfoIcon = styled(BaseInfoIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.blue[50]};
    font-size: 1.2003rem;
  }
`

export const SuccessIcon = styled(BaseSuccessIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.green[50]};
    font-size: 1rem;
  }
`

export const WarningIcon = styled(BaseWarningIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.yellow[50]};
    font-size: 1.2003rem;
  }
`
